document.addEventListener('DOMContentLoaded', function () {
    const subscriptionWrapper = document.querySelector('.product-subscription-bundles');
    if (!subscriptionWrapper) return;

    let isSubscriptionMode = true;
    let highlightedIndex = 0;

    const oneTimePurchase = subscriptionWrapper.querySelector('.product-subscription__item[data-place="0"]');
    const subscribeAndSaveTrigger = subscriptionWrapper.querySelector('.subscription-collapsable-trigger');
    const subscriptionOptionsContainer = subscriptionWrapper.querySelector('.product-subscription-options__cont');
    const dropdown = subscriptionWrapper.querySelector('.product-subscription-dropdown');
    const dropdownTrigger = dropdown?.querySelector('.product-subscription-dropdown__trigger');
    const dropdownSelected = dropdown?.querySelector('.product-subscription-dropdown__selected');
    const subscriptionPlanItems = dropdown?.querySelectorAll('.product-subscription-options__collapsable .product-subscription__item');

    const sellingPlanInput = document.getElementById('selling_plan');
    const firstSubscriptionPlanEl = subscriptionWrapper.querySelector('.product-subscription-options__collapsable .product-subscription__item[data-place="1"]');
    if (sellingPlanInput && firstSubscriptionPlanEl && firstSubscriptionPlanEl.dataset.sellingPlan) {
        sellingPlanInput.value = firstSubscriptionPlanEl.dataset.sellingPlan;
    }
    if (dropdownSelected && firstSubscriptionPlanEl) {
        const firstPlanTitleEl = firstSubscriptionPlanEl.querySelector('.product-subscription__title');
        if (firstPlanTitleEl) {
            dropdownSelected.textContent = firstPlanTitleEl.textContent.trim();
        }
    }

    // --- ARIA helpers ---

    function openDropdown() {
        dropdown.classList.add('open');
        if (dropdownTrigger) {
            dropdownTrigger.setAttribute('aria-expanded', 'true');
        }
        const selectedIndex = Array.from(subscriptionPlanItems).findIndex((item) =>
            item.classList.contains('product-subscription__item--active')
        );
        highlightedIndex = selectedIndex >= 0 ? selectedIndex : 0;
        updateHighlight();
    }

    function closeDropdown() {
        dropdown.classList.remove('open');
        if (dropdownTrigger) {
            dropdownTrigger.setAttribute('aria-expanded', 'false');
            dropdownTrigger.removeAttribute('aria-activedescendant');
        }
        subscriptionPlanItems.forEach((item) => item.removeAttribute('aria-selected'));
    }

    function updateHighlight() {
        subscriptionPlanItems.forEach((item, i) => {
            if (i === highlightedIndex) {
                item.setAttribute('aria-selected', 'true');
                if (dropdownTrigger) {
                    dropdownTrigger.setAttribute('aria-activedescendant', item.id);
                }
            } else {
                item.removeAttribute('aria-selected');
            }
        });
    }

    // --- Purchase mode helpers ---

    function activateOneTimePurchase() {
        isSubscriptionMode = false;

        const input = document.getElementById('selling_plan');
        if (input) input.value = '';

        oneTimePurchase.classList.add('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.remove('product-subscription__item--active');
        subscriptionPlanItems.forEach((item) => item.classList.remove('product-subscription__item--active'));

        dropdown.classList.remove('active');
        closeDropdown();

        subscriptionOptionsContainer.classList.remove('active');

        if (typeof updateBottlePriceOriginal === 'function') {
            updateBottlePriceOriginal(0);
        }
    }

    function activateSubscriptionMode() {
        isSubscriptionMode = true;

        oneTimePurchase.classList.remove('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
        dropdown.classList.add('active');
        subscriptionOptionsContainer.classList.add('active');

        if (typeof updateBottlePriceOriginal === 'function') {
            updateBottlePriceOriginal(1);
        }

        if (subscriptionPlanItems && subscriptionPlanItems.length > 0) {
            setTimeout(() => {
                const firstPlan = subscriptionPlanItems[0];

                const input = document.getElementById('selling_plan');
                if (input && firstPlan.dataset.sellingPlan) {
                    input.value = firstPlan.dataset.sellingPlan;
                }

                subscriptionPlanItems.forEach((opt) => opt.classList.remove('product-subscription__item--active'));
                firstPlan.classList.add('product-subscription__item--active');

                const titleEl = firstPlan.querySelector('.product-subscription__title');
                if (dropdownSelected && titleEl) {
                    dropdownSelected.textContent = titleEl.textContent.trim();
                }

                updateDynamicSubscriptionPrice(firstPlan);
            }, 100);
        }
    }

    function updateDynamicSubscriptionPrice(item) {
        const dynamicPriceEl = subscriptionWrapper.querySelector('.dynamic-subscription-price');
        const itemPriceEl = item.querySelector('.product-subscription__price .price--sale');
        if (dynamicPriceEl && itemPriceEl) {
            dynamicPriceEl.textContent = itemPriceEl.textContent.trim();
        }
    }

    function selectSubscriptionPlan(item, shouldClose = true) {
        isSubscriptionMode = true;

        const input = document.getElementById('selling_plan');
        if (input && item.dataset.sellingPlan) {
            input.value = item.dataset.sellingPlan;
        }

        oneTimePurchase.classList.remove('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
        dropdown.classList.add('active');
        subscriptionOptionsContainer.classList.add('active');

        subscriptionPlanItems.forEach((opt) => opt.classList.remove('product-subscription__item--active'));
        item.classList.add('product-subscription__item--active');

        const titleEl = item.querySelector('.product-subscription__title');
        if (dropdownSelected && titleEl) {
            dropdownSelected.textContent = titleEl.textContent.trim();
        }

        if (typeof updateBottlePriceOriginal === 'function' && item.dataset.place) {
            updateBottlePriceOriginal(parseInt(item.dataset.place));
        }

        updateDynamicSubscriptionPrice(item);

        if (shouldClose) {
            closeDropdown();
            dropdownTrigger?.focus();
        }
    }

    function ensureTriggerActiveWhenSubscriptionSelected() {
        const hasActiveSubscription = Array.from(subscriptionPlanItems).some((item) =>
            item.classList.contains('product-subscription__item--active')
        );

        if (hasActiveSubscription) {
            isSubscriptionMode = true;
            oneTimePurchase.classList.remove('product-subscription__item--active');
            subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
            dropdown.classList.add('active');

            const activeItem = Array.from(subscriptionPlanItems).find((item) =>
                item.classList.contains('product-subscription__item--active')
            );
            if (activeItem) {
                const titleEl = activeItem.querySelector('.product-subscription__title');
                if (dropdownSelected && titleEl) {
                    dropdownSelected.textContent = titleEl.textContent.trim();
                }
            }
        }
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                ensureTriggerActiveWhenSubscriptionSelected();
            }
        });
    });

    subscriptionPlanItems.forEach(function (item) {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    // --- Event listeners ---

    oneTimePurchase.addEventListener('click', function () {
        activateOneTimePurchase();
    });

    subscribeAndSaveTrigger.addEventListener('click', function () {
        if (!isSubscriptionMode) {
            activateSubscriptionMode();
        }
    });

    if (dropdownTrigger) {
        dropdownTrigger.addEventListener('click', function (e) {
            e.stopPropagation();
            if (dropdown.classList.contains('open')) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });

        dropdownTrigger.addEventListener('keydown', function (e) {
            const isOpen = dropdown.classList.contains('open');

            switch (e.key) {
                case ' ':
                case 'Enter':
                    e.preventDefault();
                    if (!isOpen) {
                        openDropdown();
                    } else {
                        selectSubscriptionPlan(subscriptionPlanItems[highlightedIndex]);
                    }
                    break;

                case 'ArrowDown':
                    e.preventDefault();
                    if (!isOpen) {
                        openDropdown();
                    } else {
                        highlightedIndex = Math.min(highlightedIndex + 1, subscriptionPlanItems.length - 1);
                        updateHighlight();
                    }
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    if (!isOpen) {
                        openDropdown();
                    } else {
                        highlightedIndex = Math.max(highlightedIndex - 1, 0);
                        updateHighlight();
                    }
                    break;

                case 'Escape':
                    e.preventDefault();
                    if (isOpen) {
                        closeDropdown();
                    }
                    break;
            }
        });
    }

    if (subscriptionPlanItems) {
        subscriptionPlanItems.forEach(function (item) {
            item.addEventListener('click', function () {
                selectSubscriptionPlan(item);
            });
        });
    }

    document.addEventListener('click', function (e) {
        if (dropdown && !dropdown.contains(e.target)) {
            closeDropdown();
        }
    });

    ensureTriggerActiveWhenSubscriptionSelected();

    if (typeof updateBottlePriceOriginal === 'function') {
        updateBottlePriceOriginal(1);
    }
});
